import {
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';

import { SearchService } from '../search/search.service';
import { SearchQueryDef } from '../search/search-query-def';

@Component({
    selector: 'test-article-multiselect',
    template: `
<div *ngIf="model | notEmpty">
    <table class="table table-sm table-borderless table-nonfluid">
        <tbody>
            <tr *ngFor="let item of model; let i = index;">
                <td class="icon-cell">
                    <a (click)="removeItem(i)" title="Remove Test Article">
                        <i class="fa fa-remove remove-item"></i>
                    </a>
                </td>
                <td>
                    {{item.TestArticle}}
                </td>
            </tr>
        </tbody>
    </table>
</div>

<climb-indirect-typeahead
        [search]="searchTestArticles"
        [resultFormatter]="testArticleFormatter"
        placeholder="Test Article..."
        (selectItem)="selectItem($event)"></climb-indirect-typeahead>
`,
    styles: [`
        .table {
            margin-bottom: 0.25em;
        }
    `]
})
export class TestArticleMultiselectComponent {
    @Input() model: any[];
    @Output() modelChange: EventEmitter<any> = new EventEmitter<any>();

    readonly MAX_SEARCH_RESULTS = 50;


    constructor(
        private _searchService: SearchService
    ) { }

    removeItem(index: number) {
        if (this.model && index >= 0 && index < this.model.length) {
            this.model.splice(index, 1);
        }

        this.modelChange.emit(this.model);
    }

    searchTestArticles = (term: string): Promise<any> => {
        let count = null;
        if (term.length < 3) {
            count = this.MAX_SEARCH_RESULTS;
        }

        const filter = {
            TestArticle: term
        };

        const searchQueryDef: SearchQueryDef = {
            entity: 'cv_TestArticles',
            page: 1,
            size: count,
            sortColumn: 'TestArticle',
            sortDirection: 'asc',
            filter
        };

        return this._searchService.getEntitiesBySearch(searchQueryDef)
            .then((results: any) => {
                return results.data;
            });
    }

    testArticleFormatter = (value: any) => {
        return value.TestArticle;
    }

    selectItem(testArticle: any) {
        if (this.model) {
            this.model.push(testArticle);
        } else {
            this.model = [testArticle];
        }

        this.modelChange.emit(this.model);
    }
}
